import React, { useState } from 'react'
import Header from '../../common/HeaderAfterLogin'
import { useLocation, useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import Loader from '../login/Loader';
import BackBar from './BackBar';
import Footer from '../../common/Footer';
import { useTranslation } from "react-i18next";
import { useRef } from 'react';
import { getData } from '../../Service/ApiMethod';
import { RECRUITER_PLAYLIST, Recruiter_Profile_Status } from '../../Service/service';
import RecommendedProfile from './component/RecommendedProfile';
import AddToListRecomended from '../Vaccancy/toggles/AddToListRecomended';
import BlackScreen from './BlackScreen';
import { Modal } from 'react-bootstrap';
import MultiRangeSlider from "multi-range-slider-react";
import { lang } from '../../lang';
export default function Candidatesearch() {
  const [value, setValue] = useState('')
  const [searchKey, setSearchKey] = useState("")
  const [popup, setPopup] = useState(false);

  const [isError, setIsError] = useState();
  const [playlist, setPlaylist] = useState();
  const [clickedId, setClickedId] = useState();
  const [iindex, setIindex] = useState();
  const [blackPopup, setBlackPopup] = useState(true);
  const [ln,setLn] = useState('en')
  // const location = useLocation()



  const pastVal = useRef()
  const [loaderStart, setLoaderstart] = useState(false)
  const lets = useRef()
  const longs = useRef()
  const { t } = useTranslation()
  const navigate = useNavigate()
  useEffect(() => {
    setLoaderstart(true)
    if(localStorage.getItem("language") != null){
      setLn(localStorage.getItem("language"))
    }
    let va = localStorage.getItem("searchValue")
    pastVal.current = va
    setValue(va)
    setTimeout(() => {
      profile_Status()
      searchDatas(pastVal.current)
    }, 1000)
  }, [])


  const isSub = useRef()
  const profile_Status = () => {
    getData(Recruiter_Profile_Status)
      .then((response) => response.json())
      .then((res) => {
        // setLoaderstart(false)

        isSub.current = res?.data?.is_subscribed
        let lat = res?.data?.latitude
        let long = res?.data?.longitude
        lets.current = res?.data?.latitude
        longs.current = res?.data?.longitude
        if (res?.data?.is_subscribed == false) {
          cateGroup(lat, long, pastVal.current)

        } else {
          searchDatas(pastVal.current)
        }
      })
      .catch((err) => {
        // setLoaderstart(false)
        console.log("profileStatusErr");
      });
  };



  const [listView, setListview] = useState([])
  const List = useRef([])


  const cateGroup = async (currentLatitude, currentLongitude, val) => {
    setLoaderstart(true);
    let search = val
    var request = {
      radius: val,
      "latitude": currentLatitude,
      "longitude": currentLongitude
    };
    console.log(request, "dxxxxxxxxx", "https://api.catzapp.com/recruiter/search_events_count/?keyword=" + search + "&latitude=" + currentLatitude + "&longitude=" + currentLongitude);
    setTimeout(() => {
      fetch("https://api.catzapp.com/recruiter/search_events_count/?keyword=" + search + "&latitude=" + localStorage.getItem('lat') + "&longitude=" + localStorage.getItem('lng'), {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("catzapp_token"),
        },
      })
        .then((response) => response.json())
        .then((res) => {
          setLoaderstart(false);
          console.log('res~~~~~~2222SEAR', res);
          setListview(res.data)
          List.current = res.data
        })
        .catch(error => { });
    }, 1000)
  }





  const [searchData, setSearchData] = useState([]);
  const [searchDatax, setSearchDatax] = useState([]);
  const daff = useRef([])
  const searchDatas = async (val) => {
    setIsopen(false)
    setLoaderstart(true);
    var request = {
      keyword: val,
      latitude: localStorage.getItem('lat'),
      longitude: localStorage.getItem('lng'),
      emp_details_id: selectedOption,
      max_distance: maxValuedis,
      min_experience: minValue,
      max_experience: maxValue,
      min_salary: minValuesal, 
      max_salary: maxValuesal,
      page_num: 1,
    };
    console.log(request, "dxxxxxxxxx999999");
    fetch("https://api.catzapp.com/recruiter/searchevent_v1/", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("catzapp_token"),
      },
      body: JSON.stringify(request),
    })
      .then((response) => response.json())
      .then((res) => {
        setLoaderstart(false);
        console.log('res~~~~~~99999999', res.data.page_num);
        console.log('iFFFFFF', res.data.candidate_list)
        daff.current = res.data.candidate_list
        if (res.data.page_num == 1) {
          console.log("11111111");
          setLoaderstart(false);

          setSearchDatax(res.data.candidate_list);
          setSearchData(res.data.candidate_list);

          //   setCountIndex(0);
          //   totalPage.current = res.data.total_pages
        }
        // } else if (pageNos.current <= totalPage.current) {

        //   console.log("22222222",myVacancyData);
        //   let valuu = searchData
        //   res.data.candidate_list.map((it)=>{
        //     valuu.push(it)
        //   })
        //   setSearchDatax(valuu);
        //   setSearchData(valuu);
        //   // setMyVacancyData(valuu)
        //   // updateVa.current = valuu
        //   // console.log("okno1",valuu);
        //   setLoader(false);
        // }else{
        //   setLoader(false);
        //   // alert("No Data More")
        // }
        // setListview(res.data.candidate_list)

      })
      .catch(error => { });
  }

  // const getPlaylist = () => {
  //   getData(RECRUITER_PLAYLIST)
  //     .then((response) => response.json())
  //     .then((data) => {
  //       setPlaylist(data.data);
  //     })
  //     .catch((err) => {
  //       console.log("Error in categories from Post Form", err);
  //       console.log(" code Error", err);
  //       setIsError(err.message);
  //       console.log(isError);
  //     });
  // };

  const [isOpen, setIsopen] = useState(false)
  const filters = () => {
    setIsopen(true)
  }

  const [minValue, set_minValue] = useState(0);
  const [maxValue, set_maxValue] = useState(0);
  const [minValuesal, set_minValuesal] = useState(0);
  const [maxValuesal, set_maxValuesal] = useState(0);
  const [maxValuedis, set_maxValuedis] = useState(0);
  const handleInput = (e) => {
    set_minValue(e.minValue);
    set_maxValue(e.maxValue);
  };

  const handleInputsal = (e) => {
    set_minValuesal(e.minValue);
    set_maxValuesal(e.maxValue);
  };

  const [selectedOption, setSelectedOption] = useState(0);

  const handleOptionChange = (e) => {
    setSelectedOption(e.target.value);
  };


  return (
    <>
    <>
     
      </>
      <Header />
      {
        loaderStart == true ? (<Loader />) : null  
      }
      <div className="wrapped-content-area vacancy pt-3" style={{  }}>
        <BackBar title={lang && Object.keys(lang).length > 0 ? lang[ln]?.Newtranslation["Candidates"]:""} />

        {/* -------------------------Search Bar-------------------- */}
        <div style={{ marginTop: '10px', display: 'flex', justifyContent: 'center',position: 'relative' }}>
          <div
            className="search-container flex-center relative candidate-search" style={{ }}
          >
            <input
              type="text"
              placeholder={value == "" ? t("Search by vacancy title") : value}
              className="search-input form-control"
              value={searchKey}
              onChange={(e) => {
                setSearchKey(e.target.value)

              }}
              onKeyDown={e => e.key === 'Enter' ? isSub.current == true ? searchDatas(searchKey) : cateGroup(lets.current, longs.current, searchKey) : ''}

            />
            <span onClick={() => {
              if (isSub.current == true) {
                set_minValue(0);
                set_maxValue(0);
                set_minValuesal(0);
                set_maxValuesal(0);
                setSelectedOption(0);
                searchDatas(searchKey)
              } else {
                cateGroup(lets.current, longs.current, searchKey)
              }

            }} style={{ cursor: 'pointer' }}>
              <img src="./images/search.png" alt="search" className="searchIcon" />
            </span>


          </div>
          <img className=''
            src={"./images/filter-icon.png"}
            alt=""
            style={{ width: 20, height: 20 }}
            onClick={() => filters()}
          />
        </div>
        {/* -------------------------Search Bar End-------------------- */}
        <div className="container-fluid" >

          <div className="my-3" >
            <div className="row" >
              {isSub.current == false ? List.current.length != 0 ? (<div className="mt-3 row">
                {
                  List.current?.map((item, index) => (
                    <div
                      className="col-lg-3 col-md-4 col-sm-6 col-12"
                      onClick={() => {

                        navigate('/subcription')
                      }}
                    >
                      <div className="recommended-profile"
                      >
                        <div className="relative flex-center d-flex flex-column" >
                          <div className="profile-img-box">
                            <img src={item?.category_icon || "../images/Vector.png"} alt="" className="profile-img"  />
                          </div>
                          <div className="d-flex flex-column align-items-center">
                            <h2 className="card-heding relative">
                              <span
                                style={{ cursor: "pointer" }}
                              >
                                {item?.category_name}
                              </span>
                            </h2>
                            <p className="designation">{item?.rec_cnt} {item?.rec_cnt == 1 ? "candidate" : "candidates"} </p>
                          </div>
                          <div className="d-flex justify-content-center">
                            <img className="padlockimg" src="../images/padlock.png" alt="" />
                          </div>
                        </div>
                      </div>
                    </div>
                  ))
                }</div>) : (<div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', fontSize: '20px', color: 'grey', marginTop: "100px", marginBottom: "100px" }}>{t('No Data Found')}</div>) : (<div className="row mt-3">
                  <>
                    {daff.current != null ?
                      (daff.current != undefined ? (
                        daff.current.length !== 0 ? (
                          daff.current?.map((item, index) => {
                            console.log("asssssss", item);
                            return (
                              <div
                                className="col-lg-4 col-md-4 col-sm-6 col-12"
                                id={item.id}
                                key={index}
                                onClick={(e) => {
                                  e.stopPropagation()
                                  setIindex(index)
                                  setBlackPopup(true)
                                  console.log('1 div')
                                }}
                              >
                                <div className="recommended-profile">
                                  <div className="row">
                                    <div className="col-lg-4 col-md-12 col-sm-12 px-0 relative flex-center">
                                  
                                    <div className='outer-box'>
                                      {item?.is_premium &&
                                        <div className="premium-tag-outer" style={{}}>
                                          <img
                                            src="./images/premium-tag.png"
                                            className="premium-tag"
                                            // title="Call"
                                            alt=""
                                          />
                                        </div>
                                      }
                  
                                        <img src={item?.image == null ? "https://www.tnprivatejobs.tn.gov.in/asset/images/profile-image-1_1.png" : item?.image} alt="" className="profile-img" />
                                 
                                      {/* <img
                        src="./images/save-profile.png"
                        alt=""
                        className="save-profile"
                        style={{ cursor: "pointer" }}
                      /> */}
                                      {/* {props?.bottom} */}
                                      </div>
                                    </div>
                                    <div className="col-lg-8 col-sm-12 col-12 pr-0">
                                      <h2 className="card-heding relative">
                                        <span
                                          style={{ cursor: "pointer" }}
                                          onClick={(e) => {
                                            e.stopPropagation()
                                            //   props?.openDetailPopup()
                                            console.log('2 div')
                                          }}
                                        >
                                          {item?.first_name + " " + item?.last_name}
                                        </span>
                                        <img
                                          src="./images/send-job.png"
                                          alt=""
                                          className="addprofile"
                                          onClick={(e) => {
                                            e.stopPropagation()
                                            setPopup(true);
                                            setClickedId(item?.user_id);
                                            console.log('3 div')
                                          }}
                                          style={{  }}
                                        />
                                        {/* {item?.is_verified ? (
                          <>
                            <img src="./images/verified.png" alt="" />
                            <span className="verified">Verified</span>
                          </>
                        ) : null} */}
                                      </h2>
                                      <p className="designation">{item?.profile_title}</p>
                                      {(parseInt(item?.availability)) > 0 &&
                                        <p className="profile-availbility">
                                          ({t('Available')} {item?.availability})
                                        </p>
                                      }

                                      <div className="row ">
                                        <div className="col-6 px-0">
                                          <p className="card-subHeading">{t('Total Experience')}</p>
                                          <p className="card-subHeading">{t('Current Location')}</p>
                                          <p className="card-subHeading">{t('Package')}</p>
                                          {/* <p className="horizontal-center">
                                            <img
                                              src="./images/match-badge.png"
                                              className="img-size18"
                                              alt="hi"
                                            />
                                            <span className="ms-1 match-profile">
                                              {parseInt(item?.percentage_match)}% {t('Match')}
                                            </span>
                                          </p> */}
                                        </div>
                                        <div className="col-6 px-0">
                                          {/* {item?.experience?.map((emp, i) => {
                              return ( */}
                                          <p className="profile-info">
                                            {item?.expected_salary} {(parseInt(item?.expected_salary) > 1) ? 'Years' : 'Year'}
                                          </p>
                                          {/* )
                            })} */}


                                          <p className="profile-info">{parseInt(item?.distance)} {t('KM Away')} </p>
                                          <p className="profile-info">
                                            {item?.currency} {item?.expected_salary} {item?.compensation_details}
                                          </p>
                                          {/* <p className="profile-last-seen" >
                              <span className="last-seen">{t('Last Seen')}</span>
                              <span style={{ color: 'blue' }}>{item?.updated_at} {t('ago')}</span>
                            </p> */}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  {/** (item?.user_id == setBlackScreenID) &&*/}
                                </div>


                                {((iindex == index) && blackPopup) &&
                                  <div className='blur-screen-full-area  flex-center ' style={{ position: 'fixed', top: '0', zIndex: '99999999999999', height: '100vh', overflow: 'auto', background: 'rgb(0, 0, 0, 0.7' }}>
                                    <BlackScreen item={item} setBlackPopupValue={setBlackPopup} style={{ position: 'fixed' }} />
                                  </div>
                                }
                              </div>
                            );
                          })
                        ) : <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', fontSize: '20px', color: 'grey', marginTop: "100px", marginBottom: '100px' }}>{t('No Data Found')}</div>
                      ) : <> {t('No Data Found')}  </>
                      ) : <> {t('No Data Found')}</>}

                    {popup ? (
                      <AddToListRecomended
                        playlist={playlist}
                        closePopup={setPopup}
                        seekerID={clickedId}
                      />
                    ) : null}
                  </>

                </div>)}
              {/* <VaccancyBox cols="col-lg-4 col-md-6 col-sm-12" vaccancies={vaccancies} isErrMessage={isErr} loader={loaderStart} /> */}
            </div>
          </div>
          {
           isOpen === true ?( 
            <div id="custom-modal" class="modal modal-filter">
        <div class="modal-content">
          
           
      
           <h5>{t("Filter candidate")}</h5> 
      
      
               <p>{lang && Object.keys(lang).length > 0 ? lang[ln]?.BlackCard["Experience"]:""} {minValue}{t("Years")} - {maxValue}{t("Years")}</p>
               <MultiRangeSlider
                 min={0}
                 max={100}
                 step={5}
                 ruler={true}
                 label={true}
                 minValue={minValue}
                 maxValue={maxValue}
                 preventWheel={false}
                 onInput={(e) => {
                   handleInput(e);
                 }}
               />
         
             <div style={{  }}> 
               <p>{lang && Object.keys(lang).length > 0 ? lang[ln]?.SearchEvents["Salary"]:""} {minValuesal}/{t("hrs")} - {maxValuesal}/{t("hrs")}</p>
               <MultiRangeSlider
                 min={0}
                 max={100}
                 step={5}
                 ruler={true}
                 label={true}
                 minValue={minValuesal}
                 maxValue={maxValuesal}
                 preventWheel={false}
                 onInput={(e) => {
                   handleInputsal(e);
                 }}
               />
             </div>
             <div style={{}}>
               <label style={{ marginRight: '10px' }}>{lang && Object.keys(lang).length > 0 ? lang[ln]?.SearchEvents["Maximum Distance"]:""}: {maxValuedis}/{t("KM")}</label>
               <input
                 type="range"
                 name="min"
                 className="distancerange"
                 min="0"
                 max="300" 
                 value={maxValuedis}
                 onChange={(e) => set_maxValuedis(e.target.value)}
               />
             </div>
             <div style={{  }}>
               <label>{t("Type of employment contract")}</label><br></br>
               <select value={selectedOption} onChange={handleOptionChange} className='candidate-select'>
                 <option value="1">{t("Full Time")}</option>
                 <option value="2">{t("Part Time")}</option>
                 <option value="3">{t("Contract")}</option>
               </select>
             </div>
             <div className='text-center' style={{display:"flex",justifyContent: "space-between"}}>
             <button className=' btn btn-primary' style={{marginTop:10}} onClick={() => {
             setIsopen(false)
             }}>{t("Cancel")}</button>
             <button className=' btn btn-primary' style={{marginTop:10}} onClick={() => {
               let val = ''
               searchDatas(val)
             }}>{t("Submit")}</button>
             </div>
             </div>
             </div>
        
         
        
     
       ):null
          }
         
        </div>
      </div>
      <Footer />
    </>
  )
}
